import React, { useState, useRef, useEffect } from 'react';
import '../styles/pageHeader.css';

const PageHeader = ({ title, actions = [] }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownRef = useRef(null);

  const isSingleAction = actions.length === 1;

  const handleAction = (action) => {
    if (action.dropdown) {
      // Toggle dropdown for this action
      setActiveDropdown(activeDropdown === action.label ? null : action.label);
    } else {
      if (action.onClick) {
        action.onClick();
      } else {
        console.log(`${action.label} clicked`);
      }
      setIsDropdownOpen(false); // Close mobile dropdown after action
    }
  };

  const handleDropdownItem = (action, item) => {
    if (item.onClick) {
      item.onClick();
    } else {
      console.log(`${item.label} clicked`);
    }
    // Don't close dropdown automatically - let it close only when clicking outside
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside the entire header actions area
      const headerActions = document.querySelector('.header-actions');
      const mobileDropdown = dropdownRef.current;
      
      if (headerActions && !headerActions.contains(event.target) && 
          mobileDropdown && !mobileDropdown.contains(event.target)) {
        setIsDropdownOpen(false);
        setActiveDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="page-header">
      <div className={`header-content ${isSingleAction ? 'single-action' : ''}`}>
        <div className="header-title">
          <h1>{title}</h1>
        </div>
        
        {/* Desktop Actions */}
        {actions.length > 0 && (
          <div className="header-actions">
            {actions.map((action, index) => (
              <React.Fragment key={action.label}>
                {index > 0 && <div className="action-separator"></div>}
                
                <div className="header-action-wrapper">
                  <button 
                    className="header-action-btn" 
                    onClick={() => handleAction(action)}
                  >
                    <i className={action.icon}></i>
                    <span>{action.label}</span>
                  </button>
                  
                  {/* Desktop Dropdown */}
                  {action.dropdown && activeDropdown === action.label && (
                    <div className="header-dropdown">
                      {action.dropdown.map((item) => (
                        <button
                          key={item.label}
                          className={`header-dropdown-item ${item.isSelected ? 'selected' : ''}`}
                          onClick={() => handleDropdownItem(action, item)}
                        >
                          {item.label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </React.Fragment>
            ))}
          </div>
        )}

        {/* Mobile Dropdown */}
        {actions.length > 0 && (
          <div className="mobile-dropdown" ref={dropdownRef}>
            <button 
              className="mobile-dropdown-btn"
              onClick={toggleDropdown}
              aria-label="Open menu"
            >
              <i className="fa-solid fa-ellipsis-vertical"></i>
            </button>
            
            <div className={`mobile-dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
              {actions.map((action) => (
                <div key={action.label}>
                  <div
                    className="mobile-dropdown-item"
                    onClick={() => handleAction(action)}
                  >
                    <i className={action.icon}></i>
                    <span>{action.label}</span>
                  </div>
                  
                  {/* Mobile Dropdown Submenu */}
                  {action.dropdown && activeDropdown === action.label && (
                    <div className="mobile-dropdown-submenu">
                      {action.dropdown.map((item) => (
                        <div
                          key={item.label}
                          className={`mobile-dropdown-subitem ${item.isSelected ? 'selected' : ''}`}
                          onClick={() => handleDropdownItem(action, item)}
                        >
                          {item.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      
      {/* Header Separator Line */}
      <div className="header-separator"></div>
    </div>
  );
};

export default PageHeader; 